import '@fontsource/inter/400.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import 'Shared/sass/style.scss'
import './src/sass/style.scss'

import { isEditByUrl, isPreviewByUrl } from 'Shared/utils/edit/editURL'
import {
  addEditorCookie,
  resetEditorCookie,
} from 'Shared/utils/edit/useEditorStatus'
import {
  addPreviewCookie,
  resetPreviewCookie,
} from 'Shared/utils/edit/usePreviewStatus'
import { getFromConfig } from 'Shared/utils/localeURL'
import {
  checkHash,
  isBrowser,
  scroller,
} from 'Shared/utils/PuxAnchorLink/puxAnchorUtils'
import { removeAllParamsWhenUTM } from 'Shared/utils/removeUTM'

const loadNonCriticalScript = (
  src: string,
  options?: {
    cfAsync?: string
  }
): void => {
  if (Array.from(document.scripts).some((script) => script.src === src)) {
    return
  }

  const script = document.createElement(`script`)
  script.type = `text/javascript`
  script.async = true
  script.src = src

  if (options?.cfAsync) {
    script.dataset.cfasync = options.cfAsync
  }

  document.head.appendChild(script)
}

const scheduleNonCriticalScripts = (callback: () => void): void => {
  const run = () => window.setTimeout(callback, 1)

  if (document.readyState === `complete`) {
    run()
    return
  }

  window.addEventListener(`load`, run, { once: true })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onClientEntry = () => {
  const LOCALE = process.env.LOCALE ? process.env.LOCALE : `en`
  const PROJECT = process.env.PROJECT
    ? process.env.PROJECT
    : `EasyRedmineGatsby`

  if (document.querySelector(`.NotFound`)) {
    removeAllParamsWhenUTM(window.location.href)
  }
  if (!window?.dataLayer) {
    window.dataLayer = []
  }
  fetch(
    process.env.GATSBY_CMS_URL +
      `/` +
      PROJECT.replace(`GatsbyAI`, ``).replace(`Gatsby`, ``) +
      `/puxapi/geolocation`
  )
    .then((response) => response.text())
    .then((data) => {
      if (data.length <= 5) {
        window?.dataLayer?.push({
          event: `geolocation_init`,
          country: data,
        })
      }
    })
    .catch((error) => error)
  resetEditorCookie()
  resetPreviewCookie()

  const culture = getFromConfig(LOCALE, `isoCode`, PROJECT)

  scheduleNonCriticalScripts(() => {
    loadNonCriticalScript(
      `https://cloud.google.com/ai/gen-app-builder/client?hl=${culture}`
    )
    loadNonCriticalScript(`https://tracker.gaconnector.com/gaconnector.js`, {
      cfAsync: `false`,
    })
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onRouteUpdate = ({ location }) => {
  if (isEditByUrl(location.pathname)) {
    addEditorCookie()
  } else {
    resetEditorCookie()
  }

  if (isPreviewByUrl(location.pathname)) {
    addPreviewCookie()
  } else {
    resetPreviewCookie()
  }

  function iOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  }

  if (iOS()) {
    document.querySelector(`#___gatsby`)?.classList.add(`is-iOS`)
  }

  let windowHash
  const offset = 0
  const duration = 800

  if (isBrowser) {
    window.gatsby_scroll_offset = offset
    window.gatsby_scroll_duration = duration
    windowHash = window.gatsby_scroll_hash
  }

  windowHash ? scroller(windowHash, offset) : checkHash(location, offset)

  if (isBrowser && windowHash) {
    window.gatsby_scroll_hash = undefined
  }
}
